import { ShoesState } from 'src/types'

export const pointSole = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = 'white'
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(16, 433) //つま先＿左下
  ctx.quadraticCurveTo(95, 481, 204, 500)
  ctx.quadraticCurveTo(290, 519, 404, 497)
  ctx.quadraticCurveTo(457, 487, 548, 488)
  ctx.quadraticCurveTo(725, 497, 846, 495) // 一番右下
  ctx.quadraticCurveTo(848, 493, 848, 493) // 奥
  ctx.quadraticCurveTo(850, 492, 850, 497)
  ctx.quadraticCurveTo(846, 533, 846, 533)

  ctx.quadraticCurveTo(835, 538, 835, 538)
  ctx.quadraticCurveTo(831, 540, 832, 544)
  ctx.quadraticCurveTo(823, 572, 823, 572)
  ctx.quadraticCurveTo(816, 574, 816, 574)
  ctx.quadraticCurveTo(816, 569, 816, 569)
  ctx.quadraticCurveTo(814, 574, 814, 574)
  ctx.quadraticCurveTo(794, 576, 794, 576)
  ctx.quadraticCurveTo(791, 572, 791, 572)
  ctx.quadraticCurveTo(789, 576, 789, 576)
  ctx.quadraticCurveTo(778, 577, 778, 577)
  ctx.quadraticCurveTo(769, 575, 769, 575) // 影ここから
  ctx.quadraticCurveTo(762, 543, 762, 543)
  ctx.quadraticCurveTo(699, 542, 699, 542)
  ctx.quadraticCurveTo(688, 576, 688, 576)
  ctx.quadraticCurveTo(675, 576, 675, 576)
  ctx.quadraticCurveTo(673, 572, 673, 572)
  ctx.quadraticCurveTo(669, 576, 669, 576)
  ctx.quadraticCurveTo(642, 574, 642, 574)
  ctx.quadraticCurveTo(639, 570, 639, 570)
  ctx.quadraticCurveTo(635, 574, 635, 574)
  ctx.quadraticCurveTo(622, 572, 622, 572)
  ctx.quadraticCurveTo(617, 539, 612, 535)
  ctx.quadraticCurveTo(484, 498, 390, 524)
  ctx.quadraticCurveTo(383, 528, 378, 561) // atomsDesignの右下
  ctx.quadraticCurveTo(365, 562, 365, 562)
  ctx.quadraticCurveTo(362, 557, 362, 557)
  ctx.quadraticCurveTo(360, 564, 360, 564)
  ctx.quadraticCurveTo(333, 565, 333, 565)
  ctx.quadraticCurveTo(331, 559, 331, 559)
  ctx.quadraticCurveTo(327, 565, 327, 565)
  ctx.quadraticCurveTo(314, 565, 314, 565)
  ctx.quadraticCurveTo(309, 530, 305, 529)
  ctx.quadraticCurveTo(267, 527, 267, 527)
  ctx.quadraticCurveTo(259, 531, 253, 562)
  ctx.quadraticCurveTo(239, 561, 239, 561)
  ctx.quadraticCurveTo(237, 554, 237, 554)
  ctx.quadraticCurveTo(232, 561, 232, 561)
  ctx.quadraticCurveTo(207, 557, 207, 557)
  ctx.quadraticCurveTo(204, 550, 204, 550)
  ctx.quadraticCurveTo(202, 555, 202, 555)
  ctx.quadraticCurveTo(191, 553, 191, 553)
  ctx.quadraticCurveTo(188, 518, 183, 515)
  ctx.quadraticCurveTo(165, 511, 165, 511) // 前から2本目の歯
  ctx.quadraticCurveTo(151, 541, 151, 541)
  ctx.quadraticCurveTo(145, 544, 134, 538)
  ctx.quadraticCurveTo(132, 532, 132, 532)
  ctx.quadraticCurveTo(129, 537, 129, 537)
  ctx.quadraticCurveTo(110, 530, 110, 530)
  ctx.quadraticCurveTo(108, 523, 108, 523)
  ctx.quadraticCurveTo(106, 528, 106, 528)
  ctx.quadraticCurveTo(99, 525, 99, 525)
  ctx.quadraticCurveTo(98, 492, 93, 487) // 前から1本目の歯
  ctx.quadraticCurveTo(86, 486, 79, 511)
  ctx.quadraticCurveTo(67, 511, 67, 511)
  ctx.quadraticCurveTo(59, 507, 59, 507)
  ctx.quadraticCurveTo(58, 500, 58, 500)
  ctx.quadraticCurveTo(55, 506, 55, 506)
  ctx.quadraticCurveTo(45, 500, 45, 500)
  ctx.quadraticCurveTo(43, 494, 43, 494)
  ctx.quadraticCurveTo(42, 498, 42, 498)
  ctx.quadraticCurveTo(38, 495, 38, 495)
  ctx.quadraticCurveTo(38, 478, 34, 461)
  ctx.quadraticCurveTo(9, 453, 16, 433)
  ctx.fill()

  // 前側のライン
  ctx.moveTo(34, 462)
  ctx.quadraticCurveTo(170, 538, 389, 526)
  // 後ろ側のライン
  ctx.moveTo(609, 536)
  ctx.quadraticCurveTo(726, 548, 834, 540)

  ctx.moveTo(324, 512)
  ctx.quadraticCurveTo(359, 513, 433, 505)
  ctx.quadraticCurveTo(467, 499, 512, 505)
  ctx.quadraticCurveTo(533, 511, 566, 508)
  ctx.quadraticCurveTo(591, 504, 638, 507)
  ctx.quadraticCurveTo(680, 509, 721, 524)
  ctx.quadraticCurveTo(748, 532, 770, 524)
  ctx.quadraticCurveTo(782, 516, 813, 510)
  ctx.quadraticCurveTo(837, 505, 848, 519)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()
  //   canvasResetter(ctx) // リセット
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
